module.exports = __webpack_public_path__ + "static/media/beach.7a600caa.svg";